export default __webpack_public_path__ + "assets/images/solutions/81d665832fb2cd4cee1d6739128b91fe.mp4";